import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { ProductIcon } from '../../../../components/ProductIcon';
import { useIncludedContacts } from '../useFeaturesDisplay';
import { getI18nTextForFeatureItem } from './customerPlatformFeatureDisplayI18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CustomerPlatformFeatureItem = ({
  skuCategoryName,
  productLevel,
  index,
  productApiName
}) => {
  const {
    includedContacts,
    loading
  } = useIncludedContacts({
    productApiName
  });
  if (loading) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    marginBlockStart: index > 0 ? '300' : undefined,
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(ProductIcon, {
      name: skuCategoryName,
      iconStyle: {
        blockSize: '32px',
        marginInlineEnd: '300'
      }
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: productLevel !== 'FREE' ? 'body-125' : undefined,
        children: getI18nTextForFeatureItem(productLevel, skuCategoryName)
      }), includedContacts && skuCategoryName === 'MARKETING_PRODUCTS' && /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.includedContacts",
        options: {
          includedContacts: /*#__PURE__*/_jsx(FormattedNumber, {
            value: includedContacts
          })
        }
      })]
    })]
  }, skuCategoryName);
};